<template>
  <div class="p-box">
    <div class="p-box__body">
      <div class="p-companyAddressForm">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form v-show="!loading" @submit.prevent="handleSubmit($event, onSubmit)">
            <div class="c-grid">
              <h2 class="c-pageTitle">{{ $t('pages.companies.paymentSetting.companyAddress.title') }}</h2>
              <div class="c-grid__items">
                <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__8">
                  <div class="p-companyAddressForm__input">
                    <ValidationProvider
                      v-slot="{ errors, value, handleChange }"
                      v-model="company_name"
                      :name="$t('models.company.address.companyName')"
                      rules="required"
                    >
                      <div class="p-companyAddressForm__input">
                        <p class="c-formLabel">
                          {{ $t('models.company.address.companyName') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange" />
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-slot="{ errors, value, handleChange }"
                      v-model="responsible_name"
                      :name="$t('models.company.address.responsibleName')"
                      rules="required"
                    >
                      <div class="p-companyAddressForm__input">
                        <p class="c-formLabel">
                          {{ $t('models.company.address.responsibleName') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange" />
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-slot="{ errors, value, handleChange }"
                      v-model="email"
                      :name="$t('models.company.address.email')"
                      rules="required|email"
                    >
                      <div class="p-companyAddressForm__input">
                        <p class="c-formLabel">
                          {{ $t('models.company.address.email') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange" />
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-slot="{ errors, value, handleChange }"
                      v-model="phone_number"
                      :name="$t('models.company.address.phoneNumber')"
                      rules="required|tel|min:10|max:11|numeric"
                    >
                      <div class="p-companyAddressForm__input">
                        <p class="c-formLabel">
                          {{ $t('models.company.address.phoneNumber') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange" />
                      </div>
                    </ValidationProvider>
                    <div class="p-companyAddressForm__prefecture">
                      <div class="c-grid__item__s__6 c-grid__item__m__6 c-grid__item__l__6">
                        <ValidationProvider
                          v-slot="{ errors, value, handleChange }"
                          v-model="postal_code"
                          :name="$t('models.company.address.postCode')"
                          rules="required|postal_code|length:7|numeric"
                        >
                          <p class="c-formLabel">
                            {{ $t('models.company.address.postCode') }}
                            <span v-for="error in errors" :key="error" class="c-error-msg">
                              {{ error }}
                            </span>
                          </p>
                          <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange" />
                        </ValidationProvider>
                      </div>
                      <div class="c-grid__item__s__6 c-grid__item__m__6 c-grid__item__l__6">
                        <ValidationProvider
                          v-slot="{ errors, value, handleChange }"
                          v-model="prefecture"
                          :name="$t('models.company.address.prefecture')"
                          rules="required"
                        >
                          <p class="c-formLabel">
                            {{ $t('models.company.address.prefecture') }}
                            <span v-for="error in errors" :key="error" class="c-error-msg">
                              {{ error }}
                            </span>
                          </p>
                          <Select :model-value="value" :options="prefecturesOption" @update:model-value="handleChange" />
                        </ValidationProvider>
                      </div>
                    </div>
                    <ValidationProvider
                      v-slot="{ errors, value, handleChange }"
                      v-model="city_street"
                      :name="$t('models.company.address.cityStreet')"
                      rules="required"
                    >
                      <div class="p-companyAddressForm__input">
                        <p class="c-formLabel">
                          {{ $t('models.company.address.cityStreet') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange" />
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-slot="{ errors, value, handleChange }"
                      v-model="building"
                      :name="$t('models.company.address.building')"
                      rules="required"
                    >
                      <div class="p-companyAddressForm__input">
                        <p class="c-formLabel">
                          {{ $t('models.company.address.building') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange" />
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="c-button c-button--right">
                <button class="c-button__item c-button__item--primary">
                  {{ $t('labels.save') }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
        <Loading v-show="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

import TextField from '../TextField'
import Select from '../Select'
import Loading from '../Loading'

export default {
  name: 'CompanyAddress',
  components: {
    TextField,
    Select,
    Loading
  },
  data() {
    return {
      company_name: '',
      responsible_name: '',
      phone_number: '',
      city_street: '',
      building: '',
      email: '',
      postal_code: '',
      prefecture: '',
    }
  },
  computed: {
    ...mapState({
      company_address: state => state.companiesCompanyAddress.company_address,
      loading: state => state.companiesCompanyAddress.loading,
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
    prefectures: function () {
      return gon.prefectures
    },
    prefecturesOption() {
      const obj = {}
      this.prefectures.forEach(v => {
        const key = Object.keys(v)[0]
        const unit = {}
        unit[v[key]] = key
        Object.assign(obj, unit)
      })
      return obj
    }
  },
  async created() {
    await this.readCompanyAddress(this.currentCompanyUuid)
    this.company_name = this.company_address.company_name || ''
    this.responsible_name = this.company_address.responsible_name || ''
    this.phone_number = this.company_address.phone_number || ''
    this.city_street = this.company_address.city_street || ''
    this.building = this.company_address.building || ''
    this.email = this.company_address.email || ''
    this.postal_code = this.company_address.postal_code || ''
    this.prefecture = this.company_address.prefecture || ''
  },
  methods: {
    ...mapActions({
      readCompanyAddress: 'companiesCompanyAddress/readCompanyAddress',
      writeCompanyAddress: 'companiesCompanyAddress/writeCompanyAddress'
    }),
    onSubmit() {
      const payload = {
        company_address: {
          company_name: this.company_name,
          responsible_name: this.responsible_name,
          phone_number: this.phone_number,
          city_street: this.city_street,
          building: this.building,
          email: this.email,
          postal_code: this.postal_code,
          prefecture: this.prefecture,
        }
      }
      this.writeCompanyAddress({ companyUuid :this.currentCompanyUuid, payload: payload})
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
